<div [formGroup]="form">
  <ng-container
    [formGroupName]="i"
    *ngFor="let contact of form?.controls; let i = index">
    <div class="contact-container-fields">
      <div class="card-form-group-container">
        <mat-form-field>
          <mat-label>{{ 'Tipo' | translate }}</mat-label>
          <mat-select formControlName="tipo">
            <mat-option></mat-option>
            <mat-option value="e-mail">{{ 'E-mail' | translate }}</mat-option>
            <mat-option value="indirzzo-postale">{{ 'Indirizzo postale' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <input
            matInput
            placeholder="Etichetta"
            formControlName="etichetta">
        </mat-form-field>
      </div>

      <div class="card-form-group-container">
        <mat-form-field>
          <input
            matInput
            placeholder="Email"
            formControlName="email">
        </mat-form-field>
        <mat-form-field>
          <input
            matInput
            placeholder="Telefono"
            formControlName="telefono">
          <!-- <mat-error *ngIf="form?.controls?.PRDI?.hasError('cap')">
            {{ 'Formato data non conforme allo standard ICCD' | translate }}
          </mat-error> -->
        </mat-form-field>
      </div>

      <div class="card-form-group-container">
        <mat-form-field>
          <input
            matInput
            placeholder="Nazione"
            formControlName="nazione">
        </mat-form-field>
        <mat-form-field>
          <input
            matInput
            placeholder="CAP"
            formControlName="cap">
        </mat-form-field>
      </div>

      <div class="card-form-group-container">
        <mat-form-field>
          <input
            matInput
            placeholder="Via"
            formControlName="via">
        </mat-form-field>
        <mat-form-field>
          <input
            matInput
            placeholder="Numero civico"
            formControlName="numeroCivico">
        </mat-form-field>
      </div>

      <mat-form-field>
        <input
          matInput
          placeholder="URL"
          formControlName="url">
      </mat-form-field>

      <button
        *roleVisibility="['create', 'update']; classNames: classNames"
        mat-raised-button
        type="button"
        (click)="removeHandler(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    mat-raised-button
    type="button"
    class="btn-add-contact"
    (click)="addHandler()">
    {{ 'Aggiungi contatto' | translate }}
  </button>
</div>
